import { combineReducers } from '@reduxjs/toolkit';
import trackerReducer from './Tracker/trackerSlice';
import notificationReducer from './Notification/userNotificationsSlice';
import overTimeReducer from './OverTimeList/overTimeSlice';
import profileReducer from './Profile/profileSlice';
import assignedDocumentsReducer from './AssignedDocuments/assignedDocumentsSlice';
import employeeModulesReducer from './EmployeeModules/employeeModulesSlice';
import jobRequestReducer from './jobRequestSlice';
import chatReducer from './chatSlice';

const rootReducer = combineReducers({
  timeTracker: trackerReducer,
  notifications: notificationReducer,
  overTime: overTimeReducer,
  profile: profileReducer,
  assignedDocuments: assignedDocumentsReducer,
  employeeModules: employeeModulesReducer,
  jobRequest:jobRequestReducer,
  chat: chatReducer,
});

export default rootReducer;
